import { MenuItem, Button, Box } from '@mui/material';
import { CustomSelect, CustomTextField, HeaderFilterBox } from '../../../common/components';
import { QUARTER_OPTIONS } from '../constants/generationControlConstants';
import { generateYearOptions } from '../utils/generationControlUtils';

const GenerationControlFilters = ({
  filter,
  handleFilter,
  onSearch,
  branches,
  plans,
  groups,
  paymentMethods,
}) => {
  const filterStyles = {
    width: { xs: '100%', sm: '48%', md: '24%' },
    mb: { xs: 1, md: 0 },
  };

  const yearOptions = generateYearOptions();

  return (
    <HeaderFilterBox variant="twoRows">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          mb: 1,
          width: '100%',
        }}
      >
        <CustomSelect
          label="Sucursal"
          labelId="branch-label"
          id="branch-select"
          name="branch"
          value={filter.branch}
          onChange={handleFilter}
          displayEmpty
          sx={filterStyles}
          size="medium"
        >
          <MenuItem value="">Todas</MenuItem>
          {branches.map((branch) => (
            <MenuItem key={branch.uuid} value={branch.uuid}>
              {branch.description}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Plan"
          labelId="plan-label"
          id="plan-select"
          name="plan"
          value={filter.plan}
          onChange={handleFilter}
          sx={filterStyles}
          size="medium"
        >
          {plans.map((plan) => (
            <MenuItem key={plan.uuid} value={plan.uuid}>
              {plan.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Grupo"
          labelId="group-label"
          id="group-select"
          name="group"
          value={filter.group}
          onChange={handleFilter}
          displayEmpty
          sx={filterStyles}
          size="medium"
        >
          <MenuItem value="">Todos</MenuItem>
          {groups.map((group) => (
            <MenuItem key={group.uuid} value={group.uuid}>
              {group.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Forma de Pago"
          labelId="paymentMethod-label"
          id="paymentMethod-select"
          name="payment_method"
          value={filter.payment_method}
          onChange={handleFilter}
          displayEmpty
          sx={filterStyles}
          size="medium"
        >
          <MenuItem value="">Todos</MenuItem>
          {paymentMethods.map((paymentMethod) => (
            <MenuItem key={paymentMethod.uuid} value={paymentMethod.uuid}>
              {paymentMethod.name}
            </MenuItem>
          ))}
        </CustomSelect>
      </Box>

      {/* Segunda fila: Trimestre, Año, Contrato, Botón */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          width: '100%',
        }}
      >
        <CustomSelect
          label="Trimestre"
          labelId="quarter-label"
          id="quarter-select"
          name="quarter"
          value={filter.quarter}
          onChange={handleFilter}
          displayEmpty
          sx={filterStyles}
          size="medium"
        >
          {QUARTER_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Año"
          labelId="year-label"
          id="year-select"
          name="year"
          value={filter.year}
          onChange={handleFilter}
          sx={filterStyles}
          size="medium"
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: '300px',
                overflow: 'auto',
              },
            },
          }}
        >
          {yearOptions.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomTextField
          label="Contrato"
          id="contract-input"
          name="contract_number"
          value={filter.contract_number}
          onChange={handleFilter}
          sx={filterStyles}
          size="medium"
        />

        <Button
          variant="contained"
          color="primary"
          onClick={onSearch}
          sx={{
            mt: 1.5,
            width: { xs: '100%', sm: '48%', md: '24%' },
            height: '56px',
            fontSize: { xs: '14px', sm: '16px' },
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            '&:hover': {
              boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
              transform: 'translateY(-1px)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          Ver Cupones
        </Button>
      </Box>
    </HeaderFilterBox>
  );
};

export default GenerationControlFilters;
